import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchBlueComponent } from './switch-blue.component';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from 'src/app/i18n/translation.module';



@NgModule({
  declarations: [
    SwitchBlueComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslationModule
  ],
  exports: [SwitchBlueComponent]
})
export class SwitchBlueModule { }
